/* global TradeInValuations */

import React, { Component } from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"

import ReplacementCarSummary from "./ReplacementCarSummary"

class LeadForm extends Component {
  static propTypes = {
    leadFormHtml: PropTypes.string,
    replacementCar: PropTypes.object,
    onEditReplacementCar: PropTypes.func,
    fieldValues: PropTypes.array,
    onFieldValuesCaptured: PropTypes.func,
    strings: PropTypes.object,
    trackFunction: PropTypes.func,
    replacementCarSearchAvailable: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.leadFormDivRef = React.createRef()
  }

  componentDidMount() {
    TradeInValuations.initLeadForm()

    this.renderReplacementCarInfo()

    this.resumeFieldsState()
  }

  componentWillUnmount() {
    // As this component is rendered manually we need to unmount it here
    if (this.replacementCarSummaryContainer) {
      ReactDOM.unmountComponentAtNode(this.replacementCarSummaryContainer)
    }
  }

  handleEditReplacementCar = (e) => {
    this.captureFieldValues()
    this.props.onEditReplacementCar(e)
  }

  // DOM hack to add some stuff until we convert the lead form to react
  // This will break if the component is re-rendered when updating props
  renderReplacementCarInfo() {
    this.replacementCarSummaryContainer =
      this.leadFormDivRef.current.querySelector(
        ".replacement-car-summary-container"
      )
    if (!this.props.replacementCar) return

    this.replacementCarSummary = ReactDOM.render(
      <ReplacementCarSummary
        onEditReplacementCar={this.handleEditReplacementCar}
        replacementCar={this.props.replacementCar}
        strings={this.props.strings.replacementCarSummary}
        replacementCarSearchAvailable={this.props.replacementCarSearchAvailable}
      />,
      this.replacementCarSummaryContainer
    )
  }

  // Saves the values in the fields so the state of the form can be "resumed"
  // Should be compatible with ie11 and edge
  captureFieldValues() {
    const form = this.leadFormDivRef.current.querySelector("form")
    const values = []
    Array.from(form.elements).forEach((field) => {
      if (
        !field.name ||
        field.disabled ||
        field.type === "file" ||
        field.type === "reset" ||
        field.type === "submit" ||
        field.type === "button"
      )
        return
      if (
        (field.type !== "checkbox" && field.type !== "radio") ||
        field.checked
      )
        values.push([field.name, field.value])
    })
    this.props.onFieldValuesCaptured(values)
  }

  // Resumes the previous state of the form
  // Currently hacks the DOM but in a future version
  // it should just update the react children components
  // Should be compatible with ie11 and edge
  resumeFieldsState() {
    const values = this.props.fieldValues

    if (!values) return

    const form = this.leadFormDivRef.current.querySelector("form")
    values.forEach(([name, value]) => {
      const elem = form.elements[name]
      if (elem && elem.value !== value) elem.value = value
      if (elem && elem.type === "checkbox") elem.checked = true
      if (elem)
        this.props.trackFunction({
          entity: "lead_form",
          element: name,
          action: "displayed",
          details: "prefilled",
          type: "micro_proceeding",
          flow: "trade_in",
        })
    })
  }

  render() {
    const { leadFormHtml } = this.props

    return (
      <React.Fragment>
        <div
          ref={this.leadFormDivRef}
          dangerouslySetInnerHTML={{ __html: leadFormHtml }}
        />
      </React.Fragment>
    )
  }
}

export default LeadForm
